import { prettify } from "../../utils/utils";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";

const columns = [
  {
    size: 100,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    filterFn: "contains",
    accessorFn: (row) => `${row.first_name} ${row.last_name}`,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Prof. Sanitario",
  },
  {
    size: 75,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    filterVariant: "select",
    accessorFn: (row) => prettify(row.profile),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Profilo",
  },
  {
    size: 75,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },

    filterFn: "contains",
    accessorKey: "phone", // TODO: CELLULARE SE NON C'è TELEFONO?
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Telefono",
  },
  {
    size: 100,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    filterFn: "contains",
    accessorKey: "email",
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Email",
  },
  {
    size: 75,
    accessorKey: "status",
    id: "is_active",
    enableColumnFilter: true,
    accessorFn: (row) => (row.is_active ? "true" : "false"),
    filterVariant: "select",
    Cell: ({ cell }) =>
      cell.getValue() === "true" ? (
        <DoneIcon color="success" />
      ) : (
        <CloseIcon color="error" />
      ),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Filtra" },
    filterSelectOptions: [
      { text: <DoneIcon color="success" />, value: "true" },
      { text: <CloseIcon color="error" />, value: "false" },
    ],
    header: "Attivo",
  },
  {
    size: 25,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    accessorKey: "org_name",
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Org",
    filterVariant: "select",
  },
];

export default columns;
